/**
* @file 搜索结果
* @author Ice(chenzhouji@baidu.com)
*/
import React, {FC} from 'react';
import {map} from 'lodash';
import {Link} from 'gatsby';
import {FlattenItem} from '@/hooks/useSearchInput/flattenTree';

type PanelProps = {
    items: FlattenItem[]
    keyword: string
}

const Panel: FC<PanelProps> = ({
    items,
    keyword
}) => {
    const result = items.length
        ? (
            <ul className="search-result">
            {map(items, item => (
                <li><Link to={item.path}>{item.name}</Link></li>
            ))}
            </ul>
        )
        : <div className="search-result--empty">No document title with this keyword was found</div>;

    return (
        <div className="search-panel">
            {result}
        </div>
    );
};

export default Panel;
